import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { Breadcrumbs, Btn, H6, H4 } from "../../../../AbstractElements";
import MySearchInput from "../../../../mycomponents/MySearchInput";
import DiningModal from "./DiningModal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { diningSelector } from "./diningSlice";
import { fetchDining, removeDiningData } from "./api";
import BarLoader from "../../../../Layout/Loader/BarLoader";
import { toast } from "react-toastify";

const Dining = () => {
  const dispatch = useDispatch();
  const { diningData, isLoading, status } = useSelector(diningSelector);
  // console.log("status:", status);
  console.log("diningData:", diningData);

  const [searchText, setSearchText] = useState("");
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(false);

  useEffect(() => {
    dispatch(fetchDining());

    //
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("searchText:", searchText);
  };

  const handleAdd = () => setIsAdd(!isAdd);
  const handleEdit = (data) => {
    setIsEdit(!isEdit);
    setEditData(data);
  };

  const functionCB = (data) => {
    if (data.success == true) {
      return toast.success(data.result?.message || "Data successfully deleted");
    } else {
      return toast.error(
        data.result?.message || "Oops.. Something went wrong Please try again"
      );
    }
  };

  const handleDelete = (id) => {
    console.log("delete id", id);
    let conf = window.confirm(
      "Are you sure you want to delete this dining data?"
    );

    if (conf) {
      dispatch(removeDiningData({ id, CB: functionCB }));
    }
    console.log(conf);
  };

  const DiningRow = diningData?.result?.data
    ?.filter((val, i) => {
      return (
        val.name.toLowerCase().includes(searchText.toLowerCase()) ||
        val.description.toLowerCase().includes(searchText.toLowerCase())
      );
    })
    
    .map((val, i) => ({
      index: i + 1,
      name: val.name,
      description: val.description,
      action: (
        <Container className="d-flex btn-showcase">
          <Btn
            attrBtn={{
              color: "primary",
              outline: true,
              onClick: () => handleEdit(val),
            }}
          >
            {"Edit"}
          </Btn>
          <Btn
            attrBtn={{
              color: "danger",
              outline: true,
              onClick: () => handleDelete(val._id),
            }}
          >
            {"Delete"}
          </Btn>
        </Container>
      ),
    }));

  const DiningColumns = [
    {
      name: <H6>#</H6>,
      selector: (row) => row.index,
      sortable: true,
      center: true,
      wrap: true,
      width: "77px",
    },
    {
      name: <H6>Name</H6>,
      selector: (row) => row.name,
      sortable: true,
      center: true,
      wrap: true,
      width: "277px",
    },
    {
      name: <H6>Description</H6>,
      selector: (row) => row.description,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: <H6>Action</H6>,
      selector: (row) => row.action,
      center: true,
      wrap: true,
      width: "555px",
    },
  ];

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };

  return (
    <Fragment>
      <DiningModal
        isOpen={isAdd}
        ModalTitle={"Add Dining Data"}
        toggler={handleAdd}
      />

      {isEdit && editData ? (
        <DiningModal
          isOpen={isEdit}
          ModalTitle={"Edit Dining Data"}
          toggler={handleEdit}
          editData={editData}
        />
      ) : null}

      <Container fluid={true}>
        <div className="d-flex">
          <Breadcrumbs
            parent="Dining Configuration"
            title="Dining Configuration"
          />

          <div className="social-tab">
            <MySearchInput
              handleSearch={handleSearch}
              searchText={searchText}
              setSearchText={setSearchText}
            />

            <Btn
              attrBtn={{
                className: "m-r-15 m-l-15 d-block",
                color: "success",
                // outline: true,
                onClick: handleAdd,
              }}
            >
              Add
            </Btn>
          </div>
        </div>

        <Row>
          <Col sm="12">
            <Card>
              <Col sm="12 box-col-12">
                <div className="social-tab">
                  <H4>DINING DATA</H4>
                </div>
              </Col>

              <CardBody>
                <div className="order-history table-responsive">
                  <DataTable
                    data={DiningRow}
                    columns={DiningColumns}
                    responsive={true}
                    pagination
                    paginationComponentOptions={paginationOptions}
                    subHeaderAlign="center"
                    progressPending={isLoading}
                    progressComponent={<BarLoader />}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Dining;
